<template>
  <div v-if="active">

    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <h2 class="title">Sua loja está quase pronta!</h2>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
        <div class="md-layout">

          <md-card class="info-card">

            <!-- ================== DADOS CLIENTE ================== -->
            <p class="description mobile-hidden text-center">
              Confirme as informações abaixo para criar a sua loja virtual.
            </p>
            <md-card-content>
              
              <form>
                <md-field class="md-form-group">
                  <md-icon>email</md-icon>
                  <label>E-mail</label>
                  <md-input v-model="client.email" type="text" disabled></md-input>

                  <span @click="changeAccount()" class="alterar-dados">
                    <md-icon>edit</md-icon>
                    <span>Alterar Cadastro</span>
                  </span>
                </md-field>

                <md-field class="md-form-group">
                  <md-icon>face</md-icon>
                  <label>Nome</label>
                  <md-input v-model="clientFullName" type="text" disabled></md-input>
                </md-field>

                <md-field class="md-form-group" v-if="business.company">
                  <md-icon>business</md-icon>
                  <label>Empresa</label>
                  <md-input v-model="business.company" type="text" disabled></md-input>
                </md-field>
                
                <md-field class="md-form-group" v-if="business.docNumber">
                  <md-icon>subtitles</md-icon>
                  <label>{{business.docType}}</label>
                  <md-input v-model="business.docNumber" type="text" disabled></md-input>
                </md-field>

                <md-field class="md-form-group" v-if="domain.base">
                  <md-icon>store</md-icon>
                  <label>Endereço da Loja Virtual</label>
                  <md-input v-model="storeAddress" type="text" disabled></md-input>
                  <span @click="changeDomain()" class="alterar-dados">                    
                    <md-icon>edit</md-icon>
                    <span>Alterar Domínio</span>
                  </span>
                </md-field>
              </form>
            </md-card-content>
          </md-card>

          <!-- ================== SERVIÇOS ================== -->
          <md-card class="info-card">
            <md-card-content class="order-resume">

              <div class="md-layout order-item">
                <div class="md-layout-item md-size-10 mx-auto">
                  <md-icon>{{plan.icon}}</md-icon>
                </div>

                <div class="md-layout-item md-size-89 mx-auto">
                  
                  <!-- MONTHLY -->
                  <div class="md-layout" v-if="order.cycle == 'monthly'">
                    <div class="md-layout-item md-size-70 mx-auto item-name">Loja Virtual</div>
                    <div class="md-layout-item md-size-30 mx-auto item-name text-right">                      
                      <small @click="changePlan()" class="alterar-dados">
                        <md-icon>edit</md-icon>
                        <span v-if="planCount > 1">Alterar Plano</span>
                      </small>
                    </div>
                    <div class="md-layout-item md-size-70 mx-auto label">Plano</div>
                    <div class="md-layout-item md-size-30 mx-auto value">{{plan.name}}</div>
                    <!-- PAGAMENTO INICIAL -->
                    <div class="md-layout-item md-size-70 mx-auto label">Pagamento inicial</div>
                    <div class="md-layout-item md-size-30 mx-auto value" v-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice())">
                      <small class="off-value">R${{$functions.currencyFormat(originalCyclePrice())}}</small> &nbsp;
                      <small>R$</small>{{$functions.currencyFormat(couponOverridePrice())}}
                    </div>
                    <div class="md-layout-item md-size-30 mx-auto value" v-else><small>R$</small>{{$functions.currencyFormat(currentCyclePrice())}}</div>
                    <!-- PRÓXIMAS MENSALIDADES -->
                    <div class="md-layout-item md-size-70 mx-auto label">Próximas mensalidades</div>
                    <div class="md-layout-item md-size-30 mx-auto value"><small>R$</small>{{$functions.currencyFormat(originalCyclePrice())}}</div>
                  </div>

                  <!-- ANNUALLY -->
                  <div class="md-layout" v-if="order.cycle == 'annually'">
                    <div class="md-layout-item md-size-70 mx-auto item-name">Loja Virtual</div>
                    <div class="md-layout-item md-size-30 mx-auto item-name text-right">                      
                      <small @click="changePlan()" class="alterar-dados">
                        <md-icon>edit</md-icon>
                        <span v-if="planCount > 1">Alterar Plano</span>
                      </small>
                    </div>
                    <div class="md-layout-item md-size-70 mx-auto label">Plano</div>
                    <div class="md-layout-item md-size-30 mx-auto value">{{plan.name}}</div>
                    <!-- PAGAMENTO ANUAL -->
                    <div class="md-layout-item md-size-50 mx-auto label">Valor anual <span class="mobile-hidden">com desconto</span></div>
                    <div class="md-layout-item md-size-50 mx-auto value" v-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice())">
                      <small class="off-value">R${{$functions.currencyFormat(originalCyclePrice())}}</small> &nbsp;
                      <small>R$</small>{{$functions.currencyFormat(couponOverridePrice())}}
                    </div>
                    <div class="md-layout-item md-size-50 mx-auto value" v-else>
                      <small class="off-value">R${{$functions.currencyFormat(originalCyclePrice())}}</small> &nbsp;
                      <small>R$</small>{{$functions.currencyFormat(currentCyclePrice())}}
                    </div>
                  </div>

                </div>
              </div>


              <div class="md-layout order-item">
                <div class="md-layout-item md-size-10 mx-auto">
                  <md-icon>email</md-icon>
                </div>

                <div class="md-layout-item md-size-89 mx-auto">
                  <div class="md-layout" v-if="order.hosting">
                    <div class="md-layout-item md-size-70 mx-auto item-name">Hospedagem + E&#8209;mails</div>
                    <div class="md-layout-item md-size-30 mx-auto item-name text-right">                      
                      <small @click="removeHosting()" class="alterar-dados">
                        <md-icon>cancel</md-icon>
                        <span @click="removeHosting">Remover Hospedagem</span>
                      </small>
                    </div>

                    <div class="md-layout-item md-size-70 mx-auto label">Contas de e-mail inclusas</div>
                    <div class="md-layout-item md-size-30 mx-auto value">{{plan.emails}}</div>

                    <div class="md-layout-item md-size-70 mx-auto label">Valor {{order.cycle == 'annually' ? "Anual" : "Mensal" }}</div>
                    <div class="md-layout-item md-size-30 mx-auto value"><small>R$</small>{{order.hostingPrice}}</div>

                  </div>
                  <div class="md-layout" v-else>
                    <md-button v-if="!order.hosting" class="md-success slim-button" @click="addHosting">Adicionar Hospedagem</md-button>
                  </div>
                  <div class="md-layout-item md-size-100 mx-auto label">
                    <i><small>
                      O serviço de hospedagem é opcional. Caso você deseje ter e-mails @{{ domain.base + "." + domain.extension }} ou 
                      manter páginas ou arquivos adicionais em um subdomínio, você precisará deste serviço.
                    </small></i>
                  </div>
                </div>
              </div>
                      
            </md-card-content>
          </md-card>

        </div>
      </div>


      <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">

        <!-- ================== TOTAL PEDIDO ================== -->
        <nav-tabs-card class="order-resume">
          <template slot="content">
            <span class="md-nav-tabs-title mobile-hidden">Pagamento</span>
            <md-tabs class="md-primary order-cycle" md-alignment="left" :md-active-tab="currentTab()"> 
              <md-tab id="tab-monthly" md-label="Mensal" md-icon="calendar_month" @click="changeCycle('monthly')">

                <div class="md-layout order-total">
                  <div class="md-layout-item md-size-60 mx-auto label">Pagamento Inicial</div>
                  <div class="md-layout-item md-size-40 mx-auto value" v-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice())">
                    <small class="off-value">R${{$functions.currencyFormat(parseInt(originalCyclePrice()) + parseInt(order.hostingPrice), 2)}}</small> &nbsp;
                    <small>R$</small>{{$functions.currencyFormat(parseInt(couponOverridePrice()) + parseInt(order.hostingPrice), 2)}}
                  </div>
                  <div class="md-layout-item md-size-40 mx-auto value" v-else><small>R$</small>{{$functions.currencyFormat(parseInt(currentCyclePrice()) + parseInt(order.hostingPrice), 2)}}</div>

                  <!-- OFERTA ADICIONAL DE PERÍODO GRATUITO -->
                  <div class="md-layout-item md-size-60 mx-auto label" v-if="totalFreeDays() > 0">Depois</div>
                  <div class="md-layout-item md-size-40 mx-auto value" v-if="totalFreeDays() > 0">{{totalFreeDays()}} dias grátis</div>

                  <div class="md-layout-item md-size-60 mx-auto label"><strong>Próximos meses</strong></div>                  
                  <div class="md-layout-item md-size-40 mx-auto value"><strong><small>R$</small>{{$functions.currencyFormat(parseInt(originalCyclePrice()) + parseInt(order.hostingPrice), 2)}}</strong></div>
                </div>

              </md-tab>

              <md-tab id="tab-annually" md-label="Anual" md-icon="grade" @click="changeCycle('annually')">

                <div class="md-layout order-total">
                  <div class="md-layout-item md-size-60 mx-auto label"><strong>Pagamento Anual</strong></div>
                  <div class="md-layout-item md-size-40 mx-auto value" v-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice())">
                    <strong>
                      <small class="off-value">R${{$functions.currencyFormat(parseInt(originalCyclePrice()) + parseInt(order.hostingPrice), 2)}}</small> &nbsp;
                      <small>R$</small>{{$functions.currencyFormat(parseInt(couponOverridePrice()) + parseInt(order.hostingPrice), 2)}}
                    </strong>
                  </div>
                  <div class="md-layout-item md-size-40 mx-auto value" v-else>
                    <strong>
                      <small class="off-value">R${{$functions.currencyFormat(parseInt(originalCyclePrice()) + parseInt(order.hostingPrice), 2)}}</small> &nbsp;
                      <small>R$</small>{{$functions.currencyFormat(parseInt(currentCyclePrice()) + parseInt(order.hostingPrice), 2)}}
                    </strong>
                  </div>
                </div>

              </md-tab>
            </md-tabs>
          </template>

          <template slot="footer">
            <a href="#" v-if="!this.showCouponAffFields && !order.coupon && !order.affid" @click="showCouponAff">Adicionar um cupom ou código de parceiro</a>
            <a href="#" v-if="!this.showCouponAffFields && !order.coupon && order.affid" @click="showCouponAff">Adicionar um cupom</a>
            <a href="#" v-if="!this.showCouponAffFields && order.coupon && !order.affid" @click="showCouponAff">Adicionar um código de parceiro</a>

            <md-field class="md-form-group" v-if="this.showCouponAffFields || order.coupon">
              <md-icon>local_activity</md-icon>
              <label :class="{'error' : couponValidated < 0}">
                <span v-if="couponValidated >= 0">{{order.couponText ? order.couponText : "Cupom"}}</span>
                <span v-else>Cupom Inválido</span>
              </label>
              <md-input v-model="coupon" v-if="!order.coupon != ''" type="text" @keydown="couponKeyDown"></md-input>
              <md-input v-model="order.coupon" v-if="order.coupon != ''" disabled type="text"></md-input>
              <button type="button" class="md-button md-round md-input-action" :class="{'remove' : order.coupon}" tabindex="-1" @click="changeCoupon">
                <md-icon>
                  <span v-if="!order.coupon">add</span>
                  <span v-if="order.coupon">remove</span>
                </md-icon>
              </button>
            </md-field>          

            <md-field class="md-form-group" v-if="this.showCouponAffFields || order.affid">
              <md-icon>supervisor_account</md-icon>
              <label>Indicação<span v-if="order.affid"> (+{{$store.state.affiliateFreeDays}} dias grátis)</span></label>
              <md-input v-model="affiliate" v-if="!order.affid > 0" type="text" @keydown="affKeyDown"></md-input>
              <md-input v-model="order.affName" v-if="order.affid > 0" disabled type="text"></md-input>
              <button type="button" class="md-button md-round md-input-action" :class="{'remove' : order.affid}" tabindex="-1" @click="changeAffiliate">
                <md-icon>
                  <span v-if="!order.affid">add</span>
                  <span v-if="order.affid">remove</span>
                </md-icon>
              </button>
            </md-field>

          </template>
        </nav-tabs-card>

        <!-- ================== PAGAMENTO ================== -->
        <nav-tabs-card class="order-payment">
          <template slot="content">
            <md-tabs class="md-success" md-alignment="left" :class="{'tab-blank': paymentMethod != 'creditcard'}">
              <md-tab id="tab-cc" md-label="Cartão" md-icon="credit_card" @click="changePaymentMethod('creditcard')">
                <credit-card ref="creditcard" :default-card-name="clientFullName"></credit-card>
              </md-tab>
              <md-tab v-if="plan.id > 301" id="tab-pix" md-label="PIX" md-icon="pix" @click="changePaymentMethod('pix')"></md-tab>
              <md-tab v-if="plan.id > 301" id="tab-boleto" md-label="Boleto" md-icon="request_quote" @click="changePaymentMethod('boleto')"></md-tab>              
            </md-tabs>

            <div class="info-card">
              <md-checkbox v-model="orderConfirm">
                <span class="check-confirmation" :class="{'failed': orderValidated == false}">
                  <span>
                    Estou ciente que minha loja será ativada imediatamente
                  </span>
                  <span v-if="!order.totalDays && paymentMethod == 'creditcard'">
                    e autorizo que as cobranças sejam feitas em meu cartão de crédito.
                  </span>
                  <span v-if="!order.totalDays && paymentMethod != 'creditcard'">                    
                    e entendo que uma cobrança do valor inicial será gerada.
                  </span>
                </span>
              </md-checkbox>              
              <md-checkbox v-model="offerConfirm" v-if="couponOverridePrice() > -1 || originalCyclePrice() > currentCyclePrice()">
                <span class="check-confirmation" v-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice()) && order.cycle == 'monthly'">
                  Entendo que essa oferta especial tem valor reduzido apenas no primeiro mês.
                </span>                
                <span class="check-confirmation" v-else-if="(couponOverridePrice() > -1) && (originalCyclePrice() > couponOverridePrice()) && order.cycle == 'annually'">
                  Entendo que estou recebendo um desconto adicional e exclusivo para um contrato de ciclo anual.
                </span>
                <span class="check-confirmation" v-else-if="(originalCyclePrice() > currentCyclePrice()) && order.cycle == 'annually'">
                  Entendo que estou recebendo um desconto especial para um contrato de ciclo anual.
                </span>
              </md-checkbox>
              <br/>
              <md-checkbox v-model="termsConfirm">
                <span class="check-confirmation" :class="{'failed': termsValidated == false}">
                  Eu confirmo que li e concordo com os <a target="_blank" href="https://www.iset.com.br/contrato">Termos de Uso</a>
                </span>
              </md-checkbox>

              <md-button @click="confirmPlan()" class="activation-btn md-success">Ativar minha loja</md-button>

            </div>

          </template>
          <span slot="footer">
            <a target="_blank" href="https://www.iset.com.br/contrato"><md-button class="slim-button md-info inverted">Termos de Uso</md-button></a>
          </span>
        </nav-tabs-card>

      </div>

    </div>
  </div>
</template>

<script>
import {
NavTabsCard,
} from "@/components";

import CreditCard from "./Checkout/CreditCard.vue";
import Swal from "sweetalert2";

export default {
components: {
  NavTabsCard,
  CreditCard
},  
props: {
  planCount: {
    type: Number,
    default: 0
  },
  active: {
    type: Boolean,
    default: false
  }
},
data() {
  return {       

    session: this.$store.state.session,
    client: this.$store.state.client,
    business: this.$store.state.business,
    domain: this.$store.state.domain,
    plan: this.$store.state.plan,
    order: this.$store.state.order,
    ecommerce: this.$store.state.ecommerce,
    hosting: this.$store.state.hosting,

    storeAddress: this.$store.state.domain.subdomain+"."+this.$store.state.domain.base+"."+this.$store.state.domain.extension,
    clientFullName: this.$store.state.client.firstName + " " + this.$store.state.client.lastName,
              
    coupon: "",
    couponValidated: 0, //0 = Não validado, 1 = Cupom Validado, -1 = Cupom Inválido

    affiliate: "",
    showCouponAffFields: false,
    
    paymentMethod: 'creditcard',
    creditCardValidated: false,

    termsConfirm: false,
    orderConfirm: false,
    offerConfirm: false,    
    termsValidated: null,
    orderValidated: null,  
    offerValidated: null,      
  };
},  

mounted: function () {
  this.$debug('Checkout => Mounted');

  this.$nextTick(function () {  
    this.session.cycle = this.session.cycle ? this.session.cycle : "monthly"    
    this.$store.commit('order', ['cycle', this.session.cycle]);
    
    this.$store.commit('order', ['hostingPrice', 27]);
    this.$store.commit('order', ['hosting', this.hosting.id > 0 ? false : true]);

    this.coupon = this.session.coupon;
    this.changeCycle(this.session.cycle);

    this.$debug(this.session);
    this.$debug(this.order);    
  })
},

computed: {
    showHosting(){
      return (!this.hosting.id > 0);
    },
  },

  watch: {
    termsConfirm(newVal) { 
      this.termsValidated = newVal;
      if (this.termsConfirm && this.orderConfirm)
        this.$functions.closeInfo();
    },
    orderConfirm(newVal) { 
      this.orderValidated = newVal; 
      if (this.termsConfirm && this.orderConfirm)
        this.$functions.closeInfo();
    },
  },

methods:{
  currentTab(){
    return 'tab-' + this.order.cycle;
  },

  changePlan(){ this.$emit("on-back"); },

  changePaymentMethod(newMethod){
    this.paymentMethod = newMethod;
    this.$store.commit('order', ['paymentMethod', newMethod]);
  },

  async changeCycle(newCycle) {
    this.$debug('checkout => changeCycle: ['+ newCycle +"]");

    this.$store.commit('order', ['cycle', newCycle != "" ? newCycle : this.session.cycle]);
    this.$store.commit('session', ['cycle', newCycle != "" ? newCycle : this.session.cycle]);
    
    await this.setCoupon();

    const newHostingPrice   = newCycle == 'annually' ? 324 : 27;
    const newEcommercePrice = this.couponOverridePrice() > 0 ? this.couponOverridePrice() : this.currentCyclePrice();

    this.$debug('PlanCheckout => newEcommercePrice = ' + newEcommercePrice);

    this.$store.commit('hosting', ['price', newHostingPrice]);
    this.$store.commit('ecommerce', ['price', newEcommercePrice]);
  },

  originalCyclePrice(){
    if (this.order.cycle == 'annually')
      return this.plan.monthly * 12;
    else return parseFloat(this.plan.monthly);
  },

  currentCyclePrice(){
    if (this.order.cycle == 'annually')
      return this.plan.annually;
    else return parseFloat(this.plan.monthly);
  },

  couponOverridePrice(){
    this.$debug('PlanCheckout => couponOverridePrice');

    if (this.couponValidated < 1) return -1;
    if (!this.order.couponCycles.includes(this.order.cycle)) return -1;

    this.$debug(this.order.couponType);
    this.$debug(this.order.couponValue);
    
    if (this.order.couponType == 'Percentage'){
      const percentage = 1 - (1 / 100) * this.order.couponValue;
      const newPrice = this.currentCyclePrice() * percentage;
      this.$store.commit('ecommerce', ['price', newPrice]);

      return parseFloat(newPrice);
    }
    else if (this.order.couponType == 'Fixed Amount'){  
      const newPrice = this.currentCyclePrice() - this.order.couponValue;
      this.$store.commit('ecommerce', ['price', newPrice]);

      return parseFloat(newPrice);
    }
    else if (this.order.couponType == 'Price Override'){  
      const newPrice = this.order.couponValue;
      this.$store.commit('ecommerce', ['price', newPrice]);

      return parseFloat(newPrice);
    }
  },

  totalFreeDays(){
    const planFreeDays = parseInt(this.plan.freeDays);
    const affFreeDays = this.order.affid > 0 ? parseInt(this.$store.state.affiliateFreeDays) : 0;
    const couponFreeDays = this.order.couponType == 'Free Setup' ? parseInt(this.order.couponValue) : 0;

    this.$store.commit('order', ['totalDays', planFreeDays + affFreeDays + couponFreeDays]);

    return this.order.totalDays;
  },

  async showCouponAff(){
    this.showCouponAffFields = true;
  },

  couponValid(){
    this.$debug('couponValid()');
    //Check Coupon
    if (!this.order.coupon) return 0;
    //Check Package
    return(this.order.couponPackages.includes(this.plan.id));

    /*********** IMPLEMENTAR **********
     * Ao adicionar um cupom válido para um ciclo diferente do atualmente escolhido, 
     * o ideal é que o ciclo seja alterado automaticamente para o mesmo do cupom
     * */
  },

  async changeCoupon(){
    if (this.order.coupon)
      this.removeCoupon();
    else 
      this.setCoupon();
  },

  async removeCoupon(){
    await this.$functions.removeCoupon();
    this.coupon = "";
    this.couponValidated = 0;    
  },

  async setCoupon(){
    this.$debug('PlanCheckout => setCoupon');
    if (!this.coupon) return -1;    

    await this.$functions.checkCoupon(this.coupon, this.plan.id, this.order.cycle);
    
    if (this.couponValid()){
      this.$debug('PlanCheckout => Coupon Validated');
      this.couponValidated = 1;
      this.coupon = this.order.coupon;
    } else {
      this.$debug('PlanCheckout => Invalid Coupon');
      this.couponValidated = -1;
      this.coupon = "";
    }

    this.$debug(this.$store.state.ecommerce);
  },

  changeAffiliate(){
    if (this.order.affid > 0){
      this.$store.commit('order', ['affid', '']);
      this.$store.commit('order', ['affName', '']);
      this.affiliate = "";
    }
    else this.$functions.checkAffiliate(this.affiliate);
  },

  changeAccount(){
    Swal.fire({
      title: "Deseja sair?",
      text: "Todos os dados preenchidos até aqui serão redefinidos",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "md-button md-danger",
      cancelButtonClass: "md-button md-success",
      confirmButtonText: "Sim, quero sair!",
      cancelButtonText: "Voltar",
      buttonsStyling: false
    }).then(result => {
      if (result.value) {
        this.$functions.resetAll(); 
        this.$router.push({ path: '/' });
      }
    });
  },

  changeDomain(){
    this.$router.push({ path: '/dominio' });
  },

  removeHosting(){ 
    this.$store.commit('order', ['hosting', false]); 
    this.$store.commit('order', ['hostingPrice', 0]);
  },
  addHosting(){ 
    this.$store.commit('order', ['hosting', true]); 
    this.$store.commit('order', ['hostingPrice', this.hosting.price]);
  },

  async confirmPlan() {
    this.$debug("PlanCheckout => confirmPlan");
    this.$debug(this.$store.state.plan);
    this.$debug(this.$store.state.order);
    this.$debug(this.$store.state.ecommerce);
    this.$debug(this.creditCardValidated.status);

    this.termsValidated = this.termsConfirm;
    this.orderValidated = this.orderConfirm;
    this.creditCardValidated = await this.$refs['creditcard'].validated();

    if (this.paymentMethod == "creditcard"){
      let creditcardData = await this.$refs['creditcard'].getData();
      this.$store.commit('order', ['creditcard', creditcardData]);
    }

    if (this.paymentMethod == "creditcard" && this.creditCardValidated.status == "error"){
      this.$debug(this.creditCardValidated.msg);
      this.$functions.showInfo(this.creditCardValidated.msg, 'danger');
    } else if (!this.termsValidated || !this.orderValidated){
      this.$debug("Accept Terms");
      this.$functions.showInfo('Por favor marque as caixas de confirmação da ativação da loja para prosseguir.', 'danger');
    }
    else {      
      this.$emit("on-confirm");
    }
  },

  couponKeyDown: function(e) {     
    if (e && e.keyCode === 13) this.setCoupon();
    if (e && (e.keyCode === 8 || e.keyCode === 46)) this.removeCoupon();
  },

  affKeyDown: function(e) { 
    if (e && e.keyCode === 13) 
      this.changeAffiliate(); 
  },  

},
};
</script>

<style lang="css" scoped>
.wrapper-full-page .container.md-offset{
  margin-top: 0px !important;
}

.md-tabs{
  overflow-x: clip;
}

.md-tabs .md-tabs-content{
  display: contents;
}

.timeline.timeline-simple{
  padding-left: 5px !important;
}
.timeline.timeline-simple::before { 
  margin-left: 5px !important;
  background-color: #999 !important;
  height: 300px;
}

.info-card .check-confirmation{
  font-size: 16px;
  color: #333;
}

.info-card .check-confirmation.failed{  
  color: red;
}

.activation-btn{
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
}

.info-card, .md-card{
  margin-bottom: 0px !important;
  padding: 10px 0 10px 0;
}

.info-card .description{
  margin-top: 0px !important;
}

.md-card-nav-tabs{  
  margin-top: 20px !important;
  margin-bottom: 30px !important;
}

.md-card .md-card-content{
  line-height: 1.0em !important;
}

.md-card .md-card-actions{
  height: 30px;
  margin-top: 20px;
}

.alterar-dados span{
  display: none;
  height: 16px;
  vertical-align: baseline;
}

.alterar-dados:hover span{  
  display: inline-flex;
}

.alterar-dados{
  cursor: pointer;
  opacity: 0.6;
  margin-right: 10px;
  font-size: 10px;
  transition: opacity 0.5s;
  transition: width 0.5s;
  display: contents;
}

.alterar-dados:hover{
  opacity: 1;
  color: red;
}

.alterar-dados .md-icon{  
  margin: 0px;
  height: 16px;
  font-size: 16px !important;
}

.alterar-dados:hover .md-icon{  
  color: red !important;
}

.order-resume .order-item {
  margin-top: 10px;
  font-size: 20px;
  font-weight: 400;
  transition: opacity 0.5s;
  opacity: 0.6;
}
.order-resume .order-item:hover{  
  opacity: 1;
}

.order-resume .md-layout-item {
  padding: 0px;
  margin: 0px;
}

.order-resume .item-name{
  border-bottom: 1px solid;
}

.order-resume .label{
  font-size: 14px !important;
}
.order-resume .label .md-icon{
  font-size: 14px !important;
}
.order-resume .label:hover .md-icon{
  color:#1565c0;
}

.order-resume .value{
  font-size: 18px;
  text-align: right;
}

.order-resume .value small{
  font-size: 10px;
}

.order-resume .slim-button.hidden{
  font-size: 12px !important;
  height: 22px !important;
}

.order-resume .slim-button .md-ripple{
  padding: 0px 10px !important;
  height: 22px !important;
}

.order-resume .order-item .slim-button.hidden{
  opacity: 0;
  transition: opacity 0.5s;
}
.order-resume .order-item:hover .slim-button.hidden{
  opacity: 1;
}

.order-resume .md-tabs-navigation{
  padding-left: 120px !important;
}

.order-resume .md-card-actions{
  display: table;
}

.md-group.small .md-button{
  height: 30px;
}

.md-button.md-round.md-info.md-theme-default{
  transition: background-color 0.5s;
  background-color: #aaa !important;
}
.md-button.md-round.md-info.md-theme-default.selected{
  background-color: #1565c0 !important;
}


.md-button.md-round .md-icon.md-theme-default.md-icon-font{
  color: #999 !important;
}

.off-value{
  text-decoration: line-through;
  color: red;
  font-size: 14px !important;
}

.md-tabs-navigation{
  padding: 15px !important;
}

.md-tabs-navigation i.md-icon.md-icon-font.md-tab-icon.md-theme-default{
  font-size: 1.6rem !important;  
}

.text-right{
  text-align: right !important;
}

.md-tabs.order-cycle button:nth-last-of-type(1){
  width: 190px !important;
  padding-left: 25px;
  text-align: left;
}

.md-tabs.order-cycle button:nth-last-of-type(1) .md-tab-label{
  width: 160px !important;
}

.md-tabs.order-cycle button:nth-last-of-type(1)::after{
  content: "2 meses grátis!";
  background-color: #43DD47AA;  
  color: white;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0px;
  padding: 0 5px 0 5px;
  border-radius: 5px;
}

.md-tabs.tab-blank {
  height: 50px !important;
}

.md-button.activation-btn{
  margin-top: 20px;
}

.md-field label.error{
  color: red !important;
}

/* MEDIA 600PX BEGIN */
@media only screen and (max-width: 600px) {
  .md-tabs-navigation {
    display: inline;
  }

  .order-resume .md-tabs-navigation{
    padding-left: 10px !important;
  }

  .md-tabs.order-cycle button:nth-last-of-type(1) .md-tab-label{
    width: 110px !important;
  }
  .md-tabs.order-cycle button:nth-last-of-type(1){
    width: 140px !important;
    padding-left: 20px;
    text-align: left;
  }
  .md-tabs.order-cycle button:nth-last-of-type(1)::after{
    content: "OFERTA";
  }

  .order-payment .md-tab-nav-button:not(.md-active){
    min-width: 70px !important;
    min-height: 45px !important;
  }

  .order-payment .md-tab-nav-button:not(.md-active) .md-tab-label{
    display: none;
  }

  .activation-card .md-card-actions{
    text-align: center;
    justify-content: center;
  }
  .subtitle{
    color:#333 !important;
    margin-bottom: 15px !important;
    font-size: 18px;
  }  

  .md-card-nav-tabs{  
    margin-top: 30px !important;
    margin-bottom: 20px !important;
  }
}  
/* MEDIA 600PX END */


</style>